<script setup lang="ts">
import TheHeader from '@apps/main/new-desktop/core/components/theHeader/TheHeader.vue';

import { AppSvgIcon, SemboRibbonDark, SemboRibbonLight } from '@libs/ui';

interface TripTypeBannerProps {
  destinationName: string | undefined;
}
const props = defineProps<TripTypeBannerProps>();
</script>

<template>
  <div class="trip-type-banner">
    <TheHeader class="sembo-header" />
    <div v-if="props.destinationName" class="trip-type-text-wraper">
      <div class="icon-wrapper">
        <div class="dashed-line" />
        <div class="destination-icon">
          <AppSvgIcon name="locationMark" color="color-white" size="24" />
        </div>
      </div>
      <div class="text">
        <span class="question">
          {{
            $t(
              'planner.trip_type_selector_panel.what_trip_type_to.what_trip_type'
            )
          }}
        </span>
        <span class="destination">
          {{
            $t(
              'planner.trip_type_selector_panel.what_trip_type_to.to_destination',
              [props.destinationName]
            )
          }}
        </span>
      </div>
    </div>
    <SemboRibbonLight class="left" />
    <SemboRibbonDark class="right" />
  </div>
</template>

<style scoped lang="scss">
.trip-type-banner {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-primary-90);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-64);
  .sembo-header {
    padding: var(--spacing-32) var(--spacing-24) 0 var(--spacing-24);
    z-index: 1;
  }
  .trip-type-text-wraper {
    padding-left: var(--spacing-48);
    display: flex;
    gap: var(--spacing-32);
    z-index: 1;
    align-items: center;

    .icon-wrapper {
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: var(--spacing-4);
      .dashed-line {
        height: 40px;
        width: 0;
        border: 1px dashed var(--color-black);
      }
      .destination-icon {
        background-color: var(--color-secondary-40);
        border-radius: var(--border-radius-8);
        padding: var(--spacing-8);

        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .text {
      color: var(--color-black);
      display: flex;
      width: 35%;
      flex-direction: column;
      gap: var(--spacing-8);
      max-width: 55%;
      .question {
        @include font-heading-1;
        font-size: 28px / 36px;
      }
      .destination {
        @include font-heading-1;
        font-size: 61px / 52px;
      }
    }
  }
  .right {
    position: absolute;
    right: 25%;
    bottom: 0;
    height: 110%;
    width: auto;
    z-index: 0;
  }
  .left {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 105%;
    width: auto;
    z-index: 0;
  }
}
</style>
